var counter = 1;

// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        //numberFilterTree: 2,
      priceMode: 'max',
    },
  	selector: {
      topSorting: '#bc-sf-filter-top-sorting-no-style',
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'productCardAlt': 'product-card-alt',

    // Grid Template
    'productGridItemHtml':  '<li class="product product-{{itemId}} {{itemLoopClass}} {{itemCycleClass}} {{itemCardType}}" data-product-item>' +
                				'<div class="product-inner">' +
                			    	'<figure class="product-card-figure">' +
                			    		'{{itemImages}}' +
                			    		'<a href="{{itemUrl}}" class="{{itemBorderClass}}"></a>' +
                			    		'<a class="product-card-overlay {{itemHideOverlayClass}}" href="{{itemUrl}}">' +
                			    			'<div class="product-card-overlay-content">' +
                			    				'{{itemCardOverlay}}' + // enableOverlay ? productCardDetailsOverlayHtml : productCardInteractionsHtml
                			    			'</div>' +
                			    		'</a>' +
                			    		'{{itemBadges}}' +
                			    	'</figure>' +
                			    	'<div class="product-card-footer" id="product-card-interactions-{{itemId}}">' +
                			    		'{{itemCardFooter}}' + // enableOverlay ? productCardInteractionsHtml : productCardDetailsHtml
                			    	'</div>' +
                			    	'<div class="product-card-footer-mobile">' +
                			    		'{{itemCardFooterMobile}}' + // productCardDetailsHtml
                			    	'</div>' +
                			  	'</div>' +
							'</li>',
							
	'productCardDetailsHtml' : 	'<div class="product-card-details">' +
								  	'<h3 class="brand">{{itemVendor}}</h3>'+
									'<h2 class="title">{{itemTitle}}</h2>' +
									'{{itemPrice}}' +
								'</div>',						

    'productCardDetailsOverlayHtml' : 	'<div class="product-card-details">' +
									      	'<h3 class="brand">{{itemVendor}}</h3>'+
									    	'<h2 class="title">{{itemTitle}}</h2>' +
									   		'{{itemPrice}}' +
									 	'</div>',
    
    'productCardInteractionsHtml' : '<div class="product-card-interactions">' +
  										'{{itemQuickShop}}' +
  										'{{itemAddToCart}}' +
  									'</div>',

	'quickShopHtml' : 	'<button class="product-card-interaction product-card-interaction-quickshop"' +
							'data-product-card-interaction-quickshop ' +
							'data-product-sha256="{{itemSHA256}}" ' +
							'data-product-url="{{itemUrl}}">' +
		  					bcSfFilterConfig.label.quickShop +
  						'</button>',

	'addToCartHtml' : 	'<button class="product-card-interaction product-card-interaction-addtocart" {{disabled}} ' +	
							'data-product-card-interaction-addtocart ' +
							'data-product-variant-id="{{variantId}}">' +
							'<span class="product-card-interaction-addtocart-available">' +
								'{{addToCartLabel}}' +
							'</span>' +
							'<span class="product-card-interaction-addtocart-error">' +
								bcSfFilterConfig.label.unAvailable +
							'</span>' +
							'<div class="product-card-interaction-addtocart-spinner">' +
								'<svg class="svg-icon icon-spinner " xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">' +
									'<path fill="currentColor" fill-rule="evenodd" d="M1.0436 10.9683C1.47582 10.9683 1.8262 11.3255 1.8262 11.7661C1.8262 17.4946 6.38122 22.1385 12.0001 22.1385C17.619 22.1385 22.174 17.4946 22.174 11.7661C22.174 11.3255 22.5244 10.9683 22.9566 10.9683C23.3889 10.9683 23.7392 11.3255 23.7392 11.7661C23.7392 18.3759 18.4835 23.7342 12.0001 23.7342C5.51677 23.7342 0.260986 18.3759 0.260986 11.7661C0.260986 11.3255 0.611372 10.9683 1.0436 10.9683Z"></path>' +
								'</svg>' +
							'</div>' +
						'</button>',

    // Pagination Template
    'previousActiveHtml': '<li class="previous"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.pagination_prev + '</a></li>',
    'previousDisabledHtml': '<li class="previous">' + bcSfFilterConfig.label.pagination_prev + '</li>',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.pagination_next + '</a></li>',
    'nextDisabledHtml': '<li class="next">' + bcSfFilterConfig.label.pagination_next +  '</li>',
    'pageItemHtml': '<li class="position">Page {{currentPage}} of {{totalPage}}</li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    
  	// Sorting Template
    'sortingHtml': '<label class="sidebar-title">' + bcSfFilterConfig.label.sorting + '</label>'+
  				   '<span class="bc-sf-sort-select select-wrapper">' +
  						'<select class="sort-by-box-okay">{{sortingItems}}</select>'+
  				   '</span>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    if (index == 1) counter = 1;

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add custom class
    var itemLoopClass = '';
    if (index == 1) {
        itemLoopClass = 'first';
    } else if (index == this.defaultSettings.general.limit) {
        itemLoopClass = 'last';
    }
    itemHtml = itemHtml.replace(/{{itemLoopClass}}/g, itemLoopClass);

    var itemCycleClass = (index % 5 == 0 || index == 1) ? 'flush' : '';
	itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);
	
	var itemBorderClass = bcSfFilterConfig.custom.imageBorders ? 'with-border' : '';
	itemHtml = itemHtml.replace(/{{itemBorderClass}}/g, itemBorderClass);

    var itemCardType = bcSfFilterConfig.custom.enableProductDetailsOverlay ? bcSfFilterTemplate.productCardAlt : '';
    itemHtml = itemHtml.replace(/{{itemCardType}}/g, itemCardType);

    var itemHideOverlayClass = (bcSfFilterConfig.custom.enableQuickShop || bcSfFilterConfig.custom.enableATC) ? '' : 'product-card-overlay--hide';
    itemHtml = itemHtml.replace(/{{itemHideOverlayClass}}/g, itemHideOverlayClass);

    // Add Images
    var itemImagesHtml = '';
    if (images.length > 0) {
        itemImagesHtml += '<img alt="{{itemTitle}}" src="' + this.optimizeImage(images[0]['src'], '512x') + '" srcset="' + this.optimizeImage(images[0]['src'], '512x') + '" />';
        if (images.length > 1) {
            itemImagesHtml += '<img alt="{{itemTitle}}" src="' + this.optimizeImage(images[1]['src'], '512x') + '" srcset="' + this.optimizeImage(images[1]['src'], '512x') + '" />';
        }
    } else {
        itemImagesHtml += '<img alt="{{itemTitle}}" src="' + bcSfFilterMainConfig.general.no_image_url + '" srcset="' + bcSfFilterMainConfig.general.no_image_url + '" />';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Badges
    var itemBadgesHtml = '',
        newTag = bcSfFilterConfig.label.new;
    itemBadgesHtml += '<div class="badges-wrapper">';
    if (data.available) {
        if (onSale) {
            itemBadgesHtml += '<span class="badge badge-sale">' + bcSfFilterConfig.label.sale + '</span>';
        }
        if (data.tags.indexOf(newTag) > -1) {
            itemBadgesHtml += '<span class="badge badge-new">' + newTag + '</span>';
        }
    } else {
        itemBadgesHtml += '<span class="badge badge-soldout">' + bcSfFilterConfig.label.soldOut + '</span>';
    }
    itemBadgesHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

	var productCardDetails = bcSfFilterTemplate.productCardDetailsHtml;
	var productCardDetailsOverlay = bcSfFilterTemplate.productCardDetailsOverlayHtml;
	var productCardInteractions = buildProductCardInteractions(data, firstVariant);

	// Add Card Overlay
    var itemCardOverlay = bcSfFilterConfig.custom.enableProductDetailsOverlay ? productCardDetailsOverlay : productCardInteractions;
    itemHtml = itemHtml.replace(/{{itemCardOverlay}}/g, itemCardOverlay);

    // Add Card Footer
    var itemCardFooter = bcSfFilterConfig.custom.enableProductDetailsOverlay ? productCardInteractions : productCardDetails;
    itemHtml = itemHtml.replace(/{{itemCardFooter}}/g, itemCardFooter);

    // Add Card Footer Mobile
	itemHtml = itemHtml.replace(/{{itemCardFooterMobile}}/g, productCardDetails);
	
	// Add Vendor
	var itemVendor = bcSfFilterConfig.custom.showBrandNames ? data.vendor : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

	// Add Price
  	var itemPrice = buildPrice(data);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPrice);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    counter++;

    return itemHtml;
};

function buildPrice(data){
	var html = '';
	var onSale = data.compare_at_price_min > data.price_min;
	if (onSale){
		html += '<p class="price sale">';
		html += '<span class="original money">' + bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat) + '</span>';
		html += '<span class="money">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</span>';
        html += '</p>';
	} else {
		html += '<p class="price"><span class="money">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</span><p>';
	}
	return html;
}

function buildProductCardInteractions(data, firstVariant) {
    var html = bcSfFilterTemplate.productCardInteractionsHtml;

	// Add quick shop
    var itemQuickShop = '';
    if (bcSfFilterConfig.custom.enableQuickShop) {
		itemQuickShop = bcSfFilterTemplate.quickShopHtml;
		itemQuickShop = itemQuickShop.replace(/{{itemSHA256}}/g, sha256(JSON.stringify(data)));
	}
	html = html.replace(/{{itemQuickShop}}/g, itemQuickShop);
	
	// Add add to cart
	var itemAddToCart = '';
    if (bcSfFilterConfig.custom.enableATC) {
		itemAddToCart = bcSfFilterTemplate.addToCartHtml;

		var disabled = firstVariant.available ? '' : 'disabled';
		itemAddToCart = itemAddToCart.replace(/{{disabled}}/g, disabled);		
		itemAddToCart = itemAddToCart.replace(/{{variantId}}/g, firstVariant.id);

		var addToCartLabel = firstVariant.available ? bcSfFilterConfig.label.addToCart : bcSfFilterConfig.label.soldOut;
		itemAddToCart = itemAddToCart.replace(/{{addToCartLabel}}/g, addToCartLabel);	
    }
    html = html.replace(/{{itemAddToCart}}/g, itemAddToCart);

    return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        var pageItemsHtml = bcSfFilterTemplate.pageItemHtml;
        pageItemsHtml = pageItemsHtml.replace(/{{currentPage}}/g, currentPage);
        pageItemsHtml = pageItemsHtml.replace(/{{totalPage}}/g, totalPage);

        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var breadcrumbHtml = '<span><a href="/">Home</a></span>';
        breadcrumbHtml += '<span class="sep">/</span> ';
        breadcrumbHtml += '<span><a href="/collections">' + bcSfFilterConfig.label.breadcrumb_collection + '</a></span> ';
        breadcrumbHtml += '<span class="sep">/</span> ';
        breadcrumbHtml += '<span>' + colInfo.title + '</span>';
        jQ('.breadcrumb-navigation').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    var self = this;

    if (bcSfFilterConfig.custom.enableQuickShop  || bcSfFilterConfig.custom.enableATC) {
        jQ('.product-card-interaction-quickshop').each(function(e) {
            var _this = this;
            jQ.ajax({
                type: "GET",
                url: jQ(_this).attr("data-product-url") + '?view=bc-sf-quickview',
                success: function(data) {
                    jQ(_this).attr('data-product-sha256', sha256(JSON.stringify(data)));
                }
            });
        });
    }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
	if (window.Atlantic){
  		new window.Atlantic();
    }
};

// sha256 of a string and display its hex digest
function sha256(ascii) {
	function rightRotate(value, amount) {
		return (value>>>amount) | (value<<(32 - amount));
	};
	
	var mathPow = Math.pow;
	var maxWord = mathPow(2, 32);
	var lengthProperty = 'length'
	var i, j; // Used as a counter across the whole file
	var result = ''

	var words = [];
	var asciiBitLength = ascii[lengthProperty]*8;
	
	//* caching results is optional - remove/add slash from front of this line to toggle
	// Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
	// (we actually calculate the first 64, but extra values are just ignored)
	var hash = sha256.h = sha256.h || [];
	// Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
	var k = sha256.k = sha256.k || [];
	var primeCounter = k[lengthProperty];
	/*/
	var hash = [], k = [];
	var primeCounter = 0;
	//*/

	var isComposite = {};
	for (var candidate = 2; primeCounter < 64; candidate++) {
		if (!isComposite[candidate]) {
			for (i = 0; i < 313; i += candidate) {
				isComposite[i] = candidate;
			}
			hash[primeCounter] = (mathPow(candidate, .5)*maxWord)|0;
			k[primeCounter++] = (mathPow(candidate, 1/3)*maxWord)|0;
		}
	}
	
	ascii += '\x80' // Append Ƈ' bit (plus zero padding)
	while (ascii[lengthProperty]%64 - 56) ascii += '\x00' // More zero padding
	for (i = 0; i < ascii[lengthProperty]; i++) {
		j = ascii.charCodeAt(i);
		if (j>>8) return; // ASCII check: only accept characters in range 0-255
		words[i>>2] |= j << ((3 - i)%4)*8;
	}
	words[words[lengthProperty]] = ((asciiBitLength/maxWord)|0);
	words[words[lengthProperty]] = (asciiBitLength)
	
	// process each chunk
	for (j = 0; j < words[lengthProperty];) {
		var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
		var oldHash = hash;
		// This is now the undefinedworking hash", often labelled as variables a...g
		// (we have to truncate as well, otherwise extra entries at the end accumulate
		hash = hash.slice(0, 8);
		
		for (i = 0; i < 64; i++) {
			var i2 = i + j;
			// Expand the message into 64 words
			// Used below if 
			var w15 = w[i - 15], w2 = w[i - 2];

			// Iterate
			var a = hash[0], e = hash[4];
			var temp1 = hash[7]
				+ (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) // S1
				+ ((e&hash[5])^((~e)&hash[6])) // ch
				+ k[i]
				// Expand the message schedule if needed
				+ (w[i] = (i < 16) ? w[i] : (
						w[i - 16]
						+ (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15>>>3)) // s0
						+ w[i - 7]
						+ (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2>>>10)) // s1
					)|0
				);
			// This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
			var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) // S0
				+ ((a&hash[1])^(a&hash[2])^(hash[1]&hash[2])); // maj
			
			hash = [(temp1 + temp2)|0].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
			hash[4] = (hash[4] + temp1)|0;
		}
		
		for (i = 0; i < 8; i++) {
			hash[i] = (hash[i] + oldHash[i])|0;
		}
	}
	
	for (i = 0; i < 8; i++) {
		for (j = 3; j + 1; j--) {
			var b = (hash[i]>>(j*8))&255;
			result += ((b < 16) ? 0 : '') + b.toString(16);
		}
	}
	return result;
};

function hex(buffer) {
    var hexCodes = [];
    var view = new DataView(buffer);
    for (var i = 0; i < view.byteLength; i += 4) {
        // Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
        var value = view.getUint32(i)
        // toString(16) will give the hex representation of the number without padding
        var stringValue = value.toString(16)
        // We use concatenation and slice for padding
        var padding = '00000000'
        var paddedValue = (padding + stringValue).slice(-padding.length)
        hexCodes.push(paddedValue);
    }

    // Join all the hex strings into one
    return hexCodes.join("");
}

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
